var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('permission-manager', { attrs: { "latchkey": "add-json-category-config" } }, [_c('el-button', { staticClass: "add-json-category-config", attrs: { "disabled": !_vm.addable || _vm.loading }, on: { "click": _vm.add } }, [_c('svg-icon', { staticClass: "add-json-config-icon", attrs: { "icon-class": "add", "size": 24 } }), _vm._v("\n    " + _vm._s(_vm.$t("playTurbo.custom.multiCustom.addBtnTips")) + "\n  ")], 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };